import { useQuery } from '@tanstack/react-query';
import { getMyExternalProjects, type ExternalProjectNode } from '../services/api/externalProjects';

/**
 * Phase 23 NAV-02 / NAV-03: fetch the current external user's bound projects
 * (active only) plus ghost ancestors. Backed by GET /api/external/me/projects.
 *
 * v4.0 Landmine #8: the underlying transport (services/api/externalProjects.ts)
 * uses fetch() directly — it does NOT route through services/api/client.ts.
 */
export function useMyExternalProjects() {
  return useQuery<ExternalProjectNode[]>({
    queryKey: ['my-external-projects'],
    queryFn: getMyExternalProjects,
  });
}
